import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, History } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

const fmt = (s) => (s ? String(s).slice(0, 16).replace("T", " ") : "—");

export default function CarePlanVersions() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [versions, setVersions] = useState([]);
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [v, p] = await Promise.all([api.get(`/care-plans/${id}/versions`), api.get(`/care-plans/${id}`)]);
      setVersions(v.data.items || []); setPlan(p.data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); }
  }, [id]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="care-plan-versions">
      <div className="flex items-center gap-3 mb-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/care-plans/${id}`)}><ArrowLeft className="w-4 h-4" /></Button>
        <div>
          <h1 className="text-xl font-semibold text-[#1F2937] flex items-center gap-2"><History className="w-5 h-5 text-[#0B7E8C]" />Care Plan History</h1>
          {plan && <div className="text-xs text-[#6B7280]">{plan.patient_name} · {plan.mrn}</div>}
        </div>
      </div>
      {loading ? <div className="text-sm text-[#6B7280] p-6">Loading…</div>
        : versions.length === 0 ? <div className="hah-card p-8 text-center text-sm text-[#94A3B8]">No published versions yet.</div>
        : (
        <div className="space-y-2">
          {versions.map((v) => (
            <div key={v.id} className="hah-card p-4" data-testid={`cpv-version-${v.version}`}>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-[#1F2937]">Version {v.version}</span>
                <span className="text-xs text-[#94A3B8]">{fmt(v.published_at)}</span>
              </div>
              <div className="text-xs text-[#6B7280] mt-1">
                Published by {v.published_by_name || "—"} · {(v.content?.goals || []).length} goals · {(v.content?.discharge_criteria || []).filter((c) => c.met).length}/{(v.content?.discharge_criteria || []).length} discharge criteria met
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
